import { createAction } from 'typesafe-actions';

// Offline Status Actions
export const setOfflineStatus = createAction('offline/SET_STATUS')<boolean>();

export const setOfflineQueueCount = createAction('offline/SET_QUEUE_COUNT')<number>();

export const addOfflineRequest = createAction('offline/ADD_REQUEST')<{
  id: number;
  url: string;
  method: string;
  timestamp: number;
  priority: 'low' | 'normal' | 'high';
  tags: string[];
}>();

export const removeOfflineRequest = createAction('offline/REMOVE_REQUEST')<number>();

export const updateOfflineRequestStatus = createAction('offline/UPDATE_REQUEST_STATUS')<{
  id: number;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  error?: string;
}>();

export const clearOfflineQueue = createAction('offline/CLEAR_QUEUE')();

export const setSyncProgress = createAction('offline/SET_SYNC_PROGRESS')<{
  isSyncing: boolean;
  progress: number;
  total: number;
  current: number;
}>();

export const setLastSyncTime = createAction('offline/SET_LAST_SYNC_TIME')<string>();

export const setOfflineMode = createAction('offline/SET_MODE')<{
  isOffline: boolean;
  reason?: string;
  timestamp: number;
}>();

// Offline Queue Management Actions
export const retryOfflineRequest = createAction('offline/RETRY_REQUEST')<number>();

export const removeFailedRequest = createAction('offline/REMOVE_FAILED_REQUEST')<number>();

export const prioritizeOfflineRequest = createAction('offline/PRIORITIZE_REQUEST')<{
  id: number;
  priority: 'low' | 'normal' | 'high';
}>();

export const tagOfflineRequest = createAction('offline/TAG_REQUEST')<{
  id: number;
  tags: string[];
}>();

// Offline Data Actions
export const saveOfflineData = createAction('offline/SAVE_DATA')<{
  key: string;
  data: any;
  timestamp: number;
  expiresAt?: number;
}>();

export const getOfflineData = createAction('offline/GET_DATA')<string>();

export const removeOfflineData = createAction('offline/REMOVE_DATA')<string>();

export const clearOfflineData = createAction('offline/CLEAR_DATA')();

// Offline Sync Actions
export const startOfflineSync = createAction('offline/START_SYNC')();

export const stopOfflineSync = createAction('offline/STOP_SYNC')();

export const syncOfflineRequests = createAction('offline/SYNC_REQUESTS')<{
  requests: any[];
  options?: {
    force?: boolean;
    priority?: 'low' | 'normal' | 'high';
    tags?: string[];
  };
}>();

export const syncOfflineData = createAction('offline/SYNC_DATA')<{
  keys: string[];
  options?: {
    force?: boolean;
    merge?: boolean;
  };
}>();

// Offline Error Actions
export const setOfflineError = createAction('offline/SET_ERROR')<{
  code: string;
  message: string;
  timestamp: number;
  requestId?: number;
}>();

export const clearOfflineErrors = createAction('offline/CLEAR_ERRORS')();

// Offline Configuration Actions
export const setOfflineConfig = createAction('offline/SET_CONFIG')<{
  maxRetries: number;
  retryDelay: number;
  maxQueueSize: number;
  enableBackgroundSync: boolean;
  syncInterval: number;
  autoSync: boolean;
  offlineStorage: boolean;
}>();

export const resetOfflineConfig = createAction('offline/RESET_CONFIG')();

// Offline Analytics Actions
export const trackOfflineEvent = createAction('offline/TRACK_EVENT')<{
  event: string;
  data: any;
  timestamp: number;
}>();

export const trackOfflineMetric = createAction('offline/TRACK_METRIC')<{
  metric: string;
  value: number;
  timestamp: number;
  tags?: Record<string, string>;
}>();

// Offline Health Actions
export const checkOfflineHealth = createAction('offline/CHECK_HEALTH')();

export const setOfflineHealth = createAction('offline/SET_HEALTH')<{
  status: 'healthy' | 'warning' | 'critical';
  issues: string[];
  lastCheck: number;
  nextCheck: number;
}>();

// Export all actions
export const offlineActions = {
  setOfflineStatus,
  setOfflineQueueCount,
  addOfflineRequest,
  removeOfflineRequest,
  updateOfflineRequestStatus,
  clearOfflineQueue,
  setSyncProgress,
  setLastSyncTime,
  setOfflineMode,
  retryOfflineRequest,
  removeFailedRequest,
  prioritizeOfflineRequest,
  tagOfflineRequest,
  saveOfflineData,
  getOfflineData,
  removeOfflineData,
  clearOfflineData,
  startOfflineSync,
  stopOfflineSync,
  syncOfflineRequests,
  syncOfflineData,
  setOfflineError,
  clearOfflineErrors,
  setOfflineConfig,
  resetOfflineConfig,
  trackOfflineEvent,
  trackOfflineMetric,
  checkOfflineHealth,
  setOfflineHealth
};
